// @ngInject
function stateConfig($stateProvider) {
    $stateProvider.state('resellerorder.manageproducts', {
        url: '/fulfill/manage/products',
        templateUrl: 'main/resellerorder/resellerorderfulfillment/manageproducts/manageproducts.tpl.html',
        controller: 'ResellerOrderManageProductsController as vm',
        resolve: {
        },
        params: {
            orderId: undefined,
            productNumber: undefined,
            usingScannerNavigation: false
        }
    });
}

// @ngInject
function ResellerOrderManageProductsController($rootScope, $state, $translate, $scope, $window, $stateParams, ResellerOrdersApiService, loadSpinnerService, ToasterService, printLanguageConfirmationDialogService) {
    var vm = this;

    //Properties
    vm.canAccess = $rootScope.canAccess;
    vm.selectedFulfilledProductsWarehouse = {};
    vm.fulfilledProducts = [];
    vm.filteredFulfilledProducts = [];
    vm.fulfilledProductsFilter = '';
    vm.pageSizes = [
        { id: 0, val: 5 },
        { id: 1, val: 10 },
        { id: 2, val: 20 },
        { id: 3, val: 50 },
        { id: 4, val: 100 },
        { id: 5, val: 200 }
    ];
    vm.selectedPageSize = vm.pageSizes[4];

    //Methods
    vm.$onInit = onInit;
    vm.$onChanges = onChanges;
    vm.toggleExpandAllProducts = toggleExpandAllProducts;
    vm.toggleExpandAllOrders = toggleExpandAllOrders;
    vm.printResellerOrderPickingList = printResellerOrderPickingList;
    vm.goToOrder = goToOrder;
    vm.goToProduct = goToProduct;
    vm.printAllResellerOrderPickingLists = printAllResellerOrderPickingLists;
    vm.filterFulfilledProducts = filterFulfilledProducts;
    vm.hasBeenPrinted = hasBeenPrinted;
    vm.getLatestPrint = getLatestPrint;
    vm.canPick = canPick;
    vm.confirmPicking = confirmPicking;
    vm.canPickAll = canPickAll;
    vm.confirmPickAll = confirmPickAll;
    vm.toggleClosePicking = toggleClosePicking;

    // Scanner navigation parameters
    vm.orderId = $stateParams.orderId;
    vm.productNumber = $stateParams.productNumber;
    vm.usingScannerNavigation = $stateParams.productNumber;

    activate();

    function activate() {
        $scope.$watch(function () { return vm.selectedFulfilledProductsWarehouse.id; }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                loadFulfilledProducts();
                saveLastUsedFulfilledProductsWarehouseId(newValue);
            }
        });
        $scope.$watch(function () { return vm.selectedPageSize.id; }, function (newValue, oldValue) {
            if (newValue !== oldValue) {
                loadFulfilledProducts();
            }
        });

        if (vm.orderId && vm.usingScannerNavigation) {
            expandOrder(vm.orderId, vm.productNumber);
        }
    }

    function onInit() {
        ResellerOrdersApiService.getWarehouses().then(function (response) {
            vm.warehouses = response.warehouses;
            var lastUsedFulfilledProductsWarehouseId = getLastUsedFulfilledProductsWarehouseId();
            vm.selectedFulfilledProductsWarehouse = _.find(vm.warehouses, function (o) { return o.id === lastUsedFulfilledProductsWarehouseId; });
        }, function (error) {
            ToasterService.showError(error.message);
        });
    }
    function onChanges() {
    }

    function canPick(lineItem) {
        return hasLink(lineItem.links, 'canPick');
    }
    function canPickAll(order) {
        var canPick = false;
        _.forEach(order.fulfillmentLineItems, function(li) {
            if (hasLink(li.links, 'canPick')) {
                canPick = true;
            }
        });

        return canPick;
    }
    function confirmPicking(lineItem) {
        if (canPick(lineItem)) {
            var request = {
                pickingConfirmations: [{
                    fulfillmentLineItemId: lineItem.id,
                    pickedQuantity: lineItem.pickableQuantity,
                    closePicking: lineItem.closePicking ? lineItem.closePicking : false
                }]
            };

            ResellerOrdersApiService.confirmFulfillmentLineItemPicking(request).then(function (response) {
                var lineItemEvent = _.find(response.events, function(o) {
                    return o.id === lineItem.id;
                });
                lineItem.links = lineItemEvent.links;

                lineItem.pickableQuantity = lineItemEvent.pickableQuantity;
                lineItem.pickedQuantity = lineItemEvent.pickedQuantity;
            }, function (error) {
                ToasterService.showError(error.message);
            });
        }
    }
    function confirmPickAll(order) {
        var request = {
            pickingConfirmations: []
        };
        _.forEach(order.fulfillmentLineItems, function(lineItem) {
            if (canPick(lineItem)) {
                request.pickingConfirmations.push({
                    fulfillmentLineItemId: lineItem.id,
                    pickedQuantity: lineItem.pickableQuantity,
                    closePicking: lineItem.closePicking ? lineItem.closePicking : false
                });
            }
        });

        ResellerOrdersApiService.confirmFulfillmentLineItemPicking(request).then(function (response) {
            _.forEach(response.events, function(ev) {
                var lineItem = _.find(order.fulfillmentLineItems, function(o) {
                    return o.id === ev.id;
                });
                if (lineItem) {
                    lineItem.links = ev.links;

                    lineItem.pickableQuantity = ev.pickableQuantity;
                    lineItem.pickedQuantity = ev.pickedQuantity;
                }
            });
        }, function (error) {
            ToasterService.showError(error.message);
        });
    }
    function toggleClosePicking(order) {
        var allAreTrue = true;
        _.forEach(order.fulfillmentLineItems, function (li) {
            if (!li.closePicking || li.closePicking === false) {
                allAreTrue = false;
            }
        });

        _.forEach(order.fulfillmentLineItems, function (li) {
            if (!allAreTrue) {
                li.closePicking = true;
                order.closeAllPickings = true;
            } else {
                li.closePicking = false;
                order.closeAllPickings = false;
            }
        });
    }

    function hasLink(links, rel) {
        var link = _.find(links, function (o) {
            return o.rel === rel;
        });

        if (link) {
            return true;
        }

        return false;
    }

    function getLatestPrint(order) {
        if (order.printLog.length > 0) {
            var print = _.last(order.printLog);

            return $translate.instant('resellerorder.hasBeenPrinted') + ': ' +
                formatDate(new Date(print.dateUTC)) + ' ' +
                $translate.instant('resellerorder.hasBeenPrintedBy') + ' ' + print.user;
        }
        return '';
    }
    function hasBeenPrinted(order) {
        return order.printLog.length > 0;
    }
    function formatDate(date) {
        if (!date) { return ''; }
        return date.getFullYear() + '-' + zeroFill(date.getMonth() + 1, 2) + '-' + zeroFill(date.getDate(), 2);
    }
    function zeroFill(number, width)
    {
        width -= number.toString().length;
        if (width > 0)
        {
            return new Array(width + ((/\./).test(number) ? 2 : 1)).join('0') + number;
        }
        return number + ''; // always return a string
    }

    function filterFulfilledProducts() {
        console.log('fulfilledProductsFilter: "' + vm.fulfilledProductsFilter + '"');

        if (vm.fulfilledProductsFilter.trim().length > 0) {
            var searchTerm = vm.fulfilledProductsFilter.trim().toLowerCase();
            vm.filteredFulfilledProducts = _.filter(vm.fulfilledProducts, function(o) {
                return o.displayArticleNumber.toLowerCase().indexOf(searchTerm) > -1 ||
                        o.articleName.toLowerCase().indexOf(searchTerm) > -1;
            });
        } else {
            vm.filteredFulfilledProducts = vm.fulfilledProducts;
        }
    }

    function goToOrder(orderId) {
        var url = $state.href('resellerorder.resellerorderview', {orderId: orderId});
        $window.open(url,'_blank');
    }
    function goToProduct(articleId) {
        var url = $state.href('product.articles.article', {articleId: articleId});
        $window.open(url,'_blank');
    }

    function printAllResellerOrderPickingLists() {
        printLanguageConfirmationDialogService.showDialog($translate.instant('common.printAll') + '?').then(function (result) {
            if (result.result === true) {
                loadSpinnerService.start('mainSpinner');
                var request = {
                    productIds: [],
                    locale: result.locale
                };
                _.forEach(vm.fulfilledProducts, function(o) { request.productIds.push(o.id); });

                ResellerOrdersApiService.getResellerOrderProductPerspectivePickingList(request).then(function (response) {
                }, function (error) {
                    ToasterService.showError(error.message);
                }).finally(function () {
                    loadSpinnerService.stop('mainSpinner');
                });
            }
        });
    }

    function printResellerOrderPickingList(productId) {
        printLanguageConfirmationDialogService.showDialog($translate.instant('order.print.pickingList') + '?').then(function (result) {
            if (result.result === true) {
                loadSpinnerService.start('mainSpinner');
                var request = {
                    productIds: [productId],
                    locale: result.locale
                };
                ResellerOrdersApiService.getResellerOrderProductPerspectivePickingList(request).then(function (response) {
                }, function (error) {
                    ToasterService.showError(error.message);
                }).finally(function () {
                    loadSpinnerService.stop('mainSpinner');
                });
            }
        });
    }

    function getLastUsedFulfilledProductsWarehouseId() {
        if ($window.localStorage.resellerorderfulfill_lastUsedFulfilledProductsWarehouseId) {
            var lastUsedFulfilledProductsWarehouseId = parseInt($window.localStorage.getItem('resellerorderfulfill_lastUsedFulfilledProductsWarehouseId'));
            if (isNaN(lastUsedFulfilledProductsWarehouseId)) { return undefined; }
            return lastUsedFulfilledProductsWarehouseId;
        }
        return undefined;
    }
    function saveLastUsedFulfilledProductsWarehouseId(id) {
        $window.localStorage.setItem('resellerorderfulfill_lastUsedFulfilledProductsWarehouseId', id);
    }

    function toggleExpandAllProducts() {
        var allAreExpanded = true;
        _.forEach(vm.fulfilledProducts, function (prod) {
            if (!prod.showOrders || prod.showOrders === false) {
                allAreExpanded = false;
            }
        });

        _.forEach(vm.fulfilledProducts, function (prod) {
            if (!allAreExpanded) {
                prod.showOrders = true;
            } else {
                prod.showOrders = false;
            }
        });
    }
    function toggleExpandAllOrders(prod) {
        var allAreExpanded = true;
        _.forEach(prod.orders, function (ord) {
            if (!ord.showOrderRows || ord.showOrderRows === false) {
                allAreExpanded = false;
            }
        });

        _.forEach(prod.orders, function (ord) {
            if (!allAreExpanded) {
                ord.showOrderRows = true;
            } else {
                ord.showOrderRows = false;
            }
        });
    }

    function loadFulfilledProducts() {
        if (vm.selectedFulfilledProductsWarehouse && vm.selectedFulfilledProductsWarehouse.id > 0) {
            loadSpinnerService.start('mainSpinner');
            var request = {
                warehouseId: vm.selectedFulfilledProductsWarehouse.id,
                pageSize: vm.selectedPageSize.val
            };
            ResellerOrdersApiService.getFulfilledProducts(request).then(function (response) {
                vm.fulfilledProducts = response.data.products;

                _.forEach(vm.fulfilledProducts, function (prod) {
                    prod.showOrders = false;

                    prod.orders = _.sortBy(prod.orders, ['orderNumber']);

                    _.forEach(prod.orders, function (ord) {
                        //if only one lineitem show immediately, otherwise hide
                        ord.showOrderRows = prod.orders.length === 1;
                    });
                });

                //Sort on ordernumber
                vm.fulfilledProducts = _.sortBy(vm.fulfilledProducts, ['displayArticleNumber']);

                //Copy to filter list
                vm.filteredFulfilledProducts = angular.copy(vm.fulfilledProducts);

                filterFulfilledProducts();

                if (vm.orderId && vm.usingScannerNavigation) {
                    expandOrder(vm.orderId, vm.productNumber);
                }

                console.log(vm.fulfilledProducts);
            }, function (error) {
                console.log(error);
            }).then(function () {
                loadSpinnerService.stop('mainSpinner');
            });
        }
    }

    function expandOrder(orderId, productNumber) {
        var product = _.find(vm.filteredFulfilledProducts, function(product) {
            return product.alternativeArticleNumber === productNumber;
        });

        if (product) {
            var order = _.find(product.orders, function(order) {
                return order.id === orderId;
            });
            if (order) {
                product.showOrders = true;
                order.showOrderRows = true;
            }
        }
    }

}

angular
    .module('resellerorder.manageproducts', [])
    .config(stateConfig)
    .controller('ResellerOrderManageProductsController', ResellerOrderManageProductsController);
